// extracted by mini-css-extract-plugin
export default {"bar-chart-container":"MonthlyExpensesBarChart_bar-chart-container__M8mGR"};